import { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

const ADMIN_EMAIL = 'silviasolt@gmail.com';
const MEMBER_EMAILS = ['official.sk@hotmail.com', 'szabolcs.solt@gmail.com'];

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get initial session (handles magic link redirect automatically)
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    // Listen for sign in / sign out
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const signIn = async (email) => {
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: window.location.origin,
      },
    });
    return { error };
  };

  const signOut = async () => {
    await supabase.auth.signOut();
  };

  const isAdmin = user?.email === ADMIN_EMAIL;
  const isMember = !isAdmin && MEMBER_EMAILS.includes(user?.email);

  // Friendly display names for known members
  const MEMBER_NAMES = { 'official.sk@hotmail.com': 'Mom', 'szabolcs.solt@gmail.com': 'Szabolcs' };

  const displayName = user
    ? (MEMBER_NAMES[user.email] || user.user_metadata?.display_name || user.email.split('@')[0])
    : null;

  return (
    <AuthContext.Provider value={{ user, isAdmin, isMember, displayName, loading, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
